export const Information = ({ t }) => {
  const paragraphs = t('event.description.paragraphs', { returnObjects: true });
  return (
    <>
      <h4 className='mt-3 mb-3 '>{t('event.description.title')}</h4>
      <p>
        O evento integra a programação comemorativa dos 150 anos do Estadão, com
        o objetivo de explorar as principais inovações tecnológicas que já estão
        transformando a sociedade e os setores produtivos e, sobretudo, oferecer
        um olhar visionário para os desafios e as oportunidades dos próximos
        anos.
      </p>
      <h4 className='mt-3 mb-3 '>Cancelamento de inscrições</h4>
      <p>
        Para cancelamento até 30/04/25 será devolvido o valor total do ingresso.
      </p>
      <p>
        Para cancelamento até 10/05/25 será devolvido valor parcial de 50% do
        ingresso.
      </p>
      <p>Após dia 11/05/25 não haverá devolução.</p>
      {/* {paragraphs.map((paragraph, index) => (
        <p
          key={index}
          className='mb-3'
        >
          {paragraph}
        </p>
      ))} */}
      {/* <p>
        <strong>Incluso no pacote:</strong>
      </p>
      <ul>
        <li>Espaço do Treinamento</li>
        <li>
          Alimentação durante o treinamento (almoço, coffee break manhã e tarde)
        </li>
        <li>Produtos para Prática</li>
        <li>Material de Apoio</li>
        <li>Kit Boas Vindas</li>
      </ul>

      <p>
        <strong>O que não está incluso:</strong>
      </p>
      <ul>
        <li>Translado até SP</li>
        <li>Hospedagem</li>
        <li>Jantar</li>
      </ul>

      <p>
        <strong>Responsabilidades do Franqueado:</strong>
      </p>
      <ul>
        <li>Realizar a compra de passagem e hospedagem do participante.</li>
        <li>
          A hospedagem fica a critério do franqueado. Sugerimos que seja próximo
          ao local do evento. (Para apoio, disponibilizaremos futuramente
          sugestões de hospedagem, mas fique à vontade para reservar onde
          preferir).
        </li>
      </ul>

      <p>
        <strong>Informações adicionais:</strong>
      </p>
      <ul>
        <li>
          Como nossa programação começa cedo, sugerimos que os participantes
          cheguem no dia anterior e retornem após as 21h.
        </li>
      </ul> */}
    </>
  );
};
